<template>
  <span class="usb-header-results">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small color="primarytext" aria-label="View API results" v-bind="attrs" v-on="on"
          @click="showResults = true">
          <v-icon small>mdi-code-json</v-icon>
        </v-btn>
      </template>
      <span>View Disposition and Asset Info Results</span>
    </v-tooltip>
    <v-dialog v-model="showResults" max-width="900" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          US Bank API Results
          <v-spacer />
          <v-btn icon aria-label="Close API results" @click="showResults = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-tabs v-model="activeTab" color="primarytext">
          <v-tab>Disposition</v-tab>
          <v-tab>Asset Info</v-tab>
        </v-tabs>
        <v-card-text>
          <pre v-if="selectedResult != null" class="usb-api-result-json">{{ resultText }}</pre>
          <p v-else class="my-4">No {{ activeTab === 0 ? 'disposition' : 'asset info' }} result available.</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  props: {
    disposition: { default: null },
    assetInfo: { default: null },
  },
  data() {
    return { showResults: false, activeTab: 0 };
  },
  computed: {
    selectedResult() {
      return this.activeTab === 0 ? this.disposition : this.assetInfo;
    },
    resultText() {
      return typeof this.selectedResult === "string"
        ? this.selectedResult
        : JSON.stringify(this.selectedResult, null, 2);
    },
  },
};
</script>

<style scoped>
.usb-header-results {
  flex: 0 0 32px;
  margin-left: auto;
}

.usb-api-result-json {
  max-height: 60vh;
  margin: 16px 0 0;
  overflow: auto;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 13px;
  line-height: 1.5;
}
</style>
